import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../../../shared";
import { PredefinedMessageContainer } from "../../../../../../../models/mongodbSchema/aggregates";


@Injectable({ providedIn: 'root' })
export class PredefinedMessageService extends BaseApiTemplateService<PredefinedMessageContainer>{

  constructor(private http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'predefined-message';
    this.httpClient = http;
  }
}
